import { FC } from 'react';

import { Transaction } from '@ravago/shared/page-data/models/elements';

import { OpenInvoiceCard } from './open-invoice-card';

type Props = {
   currency: string;
   invoices: Transaction[];
   canPayOnline: boolean;
   selectedInvoiceIds: number[];
   onInvoiceSelectChange: (invoiceId: number, selected: boolean) => void;
};

export const OpenInvoiceTableMobile: FC<Props> = ({ currency, invoices, canPayOnline, selectedInvoiceIds, onInvoiceSelectChange }) => {
   const handleInvoiceSelectChange = (invoiceId: number, selected: boolean) => {
      onInvoiceSelectChange(invoiceId, selected);
   };

   return invoices.map((invoice, index) => (
      <OpenInvoiceCard
         // eslint-disable-next-line react/no-array-index-key
         key={index}
         currency={currency}
         invoice={invoice}
         canPayOnline={canPayOnline}
         selected={selectedInvoiceIds.includes(invoice.id)}
         onSelect={(selected) => handleInvoiceSelectChange(invoice.id, selected)}
      />
   ));
};
